import { useCallback, FC } from "react";
import Button from "../Button";
import { Section } from "../Section";
import { useFormContext } from "../Form";
import { SubmitButton } from "../FormElements";

export interface FormSectionHeaderProps {
  title: string;
  readOnly: boolean;
  setReadOnly: (readOnly: boolean) => void;
}

/**
 * @deprecated
 */
export const FormSectionHeader: FC<FormSectionHeaderProps> = ({ title, readOnly, setReadOnly }: FormSectionHeaderProps) => {
  const { reset } = useFormContext();

  const handleEdit = useCallback(() => {
    setReadOnly(false);
  }, []);

  const handleReset = useCallback(() => {
    reset();
    setReadOnly(true);
  }, []);

  return (
    <Section.Header>
      <Section.Title>{title}</Section.Title>
      <SectionDetails handleEdit={handleEdit} handleReset={handleReset} readOnly={readOnly} />
    </Section.Header>
  );
};

export interface SectionDetailsProps {
  handleReset: () => void;
  handleEdit: () => void;
  readOnly: boolean;
}

const SectionDetails = (props: SectionDetailsProps): JSX.Element => {
  const { handleEdit, handleReset, readOnly } = props;

  if (readOnly) {
    return (
      <Section.Details>
        <Button
          ariaLabel="edit"
          id="edit-button"
          testId="edit-button"
          className="section-button"
          icon="edit"
          size="xsmall"
          onClick={handleEdit}
        >
          <p style={{ marginLeft: "8px" }}>edit</p>
        </Button>
      </Section.Details>
    );
  }

  return (
    <Section.Details>
      <Button ariaLabel="cancel" testId="cancel-button" id="cancel-button" className="section-button" size="xsmall" onClick={handleReset}>
        <p style={{ marginTop: "revert" }}>cancel</p>
      </Button>
      <SubmitButton testId="submit-button" id="submit-button" className="section-button" size="xsmall">
        save
      </SubmitButton>
    </Section.Details>
  );
};
